import axios from 'axios'
import qs from 'qs'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

//请求时的拦截器
axios.interceptors.request.use(config => {
	// 这里可以加一些动作, 比如来个进度条开始动作,
	NProgress.start()
	return config
}, error => {
	return Promise.reject(error)
})

//请求完成后的拦截器 优先于后面的checkstatus checkcode
axios.interceptors.response.use(function(response) {
	return response;
}, function(error) {
	// Do something with response error
	return Promise.resolve(error);
});

export default {
	post(url, data) {
		return axios({
			method: 'post', // 请求协议
			url: url, // 请求的地址
			data: qs.stringify(data), // post 请求的数据
			timeout: 30000, // 超时时间, 单位毫秒
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			}
		}).then(checkStatus).then(checkCode)
	},
	get(url, params) {
		return axios({
			method: 'get',
			url: url,
			params, // get 请求时带的参数
			timeout: 30000,
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(checkStatus).then(checkCode)
	}
}

//检测接口状态 status: 200 statusText: "OK"
function checkStatus(response) {
	NProgress.done()
	if (response.status === 200 || response.status === 304) {
		return response
	}
	return {
		data: {
			code: -404,
			message: response.statusText,
			data: response.statusText,
		}
	}
}

//检测接口返回的status  0 失败
function checkCode(res) {
	if (res.data.code != 1) {
		// alert(res.data.message)
	}
	return res
}



// WEBPACK FOOTER //
// ./src/api.js